import { FragmentType, getFragmentData } from '@/__generated__';
import { CustomerForm } from '@/features/customer/components/CustomerForm';
import { useMutation } from '@apollo/client';
import { ActionIcon, Avatar, Box, Group, Paper, Stack, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconEdit } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { orderCustomerDetailsFragment } from '../graphql/fragments';
import { updateOrderCustomerDocument } from '../graphql/mutations';

export const OrderCustomerCard = ({
  orderId,
  ...props
}: {
  orderId: string;
  customer: FragmentType<typeof orderCustomerDetailsFragment>;
}) => {
  const customer = getFragmentData(orderCustomerDetailsFragment, props.customer);

  const [updateOrderCustomer, { loading }] = useMutation(updateOrderCustomerDocument, {
    onCompleted: (data) => {
      const customer = getFragmentData(
        orderCustomerDetailsFragment,
        data.updateOrderCustomer.customer
      );

      modals.closeAll();
      notifications.show({
        title: 'Order customer updated',
        message: `Customer ${customer.name} updated successfully`,
        color: 'teal',
      });
    },
  });

  const handleUpdate = () =>
    modals.open({
      title: 'Update customer',
      children: (
        <CustomerForm
          customer={customer}
          loading={loading}
          onSubmit={(input) =>
            void updateOrderCustomer({
              variables: {
                orderId,
                input,
              },
            })
          }
        />
      ),
    });

  return (
    <Paper p="md" withBorder component={Stack}>
      <Group justify="space-between">
        <Text fw={500} size="lg">
          Zákazník
        </Text>
        <ActionIcon onClick={handleUpdate}>
          <IconEdit size={16} />
        </ActionIcon>
      </Group>
      <Group>
        <Avatar size="lg" src={customer.avatar} name={customer.name} />
        <Box>
          <Text fw={500}>{customer.name}</Text>
          <Text size="sm" c="dimmed">
            {dayjs(customer.createdAt).format('DD MMM YYYY HH:mm')}
          </Text>
        </Box>
      </Group>
    </Paper>
  );
};
